export const faqsBannerContent = (
    <div className='text-2xl'>
      FAQs
    </div>
  )